"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.filter.group': 'Filtruj według grupy',
    'knowledge.filter.all_groups': 'Wszystkie grupy',
    'knowledge.filter.assigned_only': 'Pokaż tylko przypisaną wiedzę',
    'knowledge.filter.by_avatar': 'Filtruj według Avatara',
    'knowledge.filter.all_avatars': 'Wszystkie Avatary',
};
